import {FC, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router";
import {Container, Nav, Navbar} from "react-bootstrap";
import clsx from "clsx";

export const Header: FC = () => {
	const {t} = useTranslation();
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 24);
		onScroll();
		window.addEventListener("scroll", onScroll, {passive: true});
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	return (
		<Navbar expand="lg" fixed="top" className={clsx("header", scrolled && "header--scrolled")}>
			<Container>
				<Navbar.Brand to="/" as={Link}>
					<img src="/images/logo.svg" alt={t("siteName")} height={54} />
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="main-menu" />
				<Navbar.Collapse id="main-menu">
					<Nav className="ms-auto menu menu--horizontal">
						<Nav.Link href="#features">{t("header.features")}</Nav.Link>
						<Nav.Link href="#how-it-works">{t("header.howItWorks")}</Nav.Link>
						{/* <Nav.Link href="#pricing">{t("header.pricing")}</Nav.Link> Pricing temporarily hidden */}
						<Nav.Link href="#faq">{t("header.faq")}</Nav.Link>
					</Nav>
					{/* Login hidden until the app goes live */}
					{/* <a className="header__login ms-lg-3" href={FRONT_END_URL}>{t("cta.login")}</a> */}
					<button type="button" className="btn btn-primary header__cta ms-lg-3" disabled>
						{t("cta.comingSoon")}
					</button>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
};
